namespace appn.views.users.createOrEdit {
    class InitArgs {
        dataSourcesAjaxGetDataSourceColumnValues: string = emptyString;
        isEnterpriseToolkit: boolean = false;
        isEmailessLoginEnabled: boolean = false;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        togglePerms(true);
        addEvents();

        minicolors.init(undefined, true);

        populateDsColumnValuesOnLoad();
    }

    function addEvents() {
        // Toggle show/hide of Website Access Roles
        $('#UserDetail_HasWebAccess').change(function(): void {
            const hasAuthMethods = utils.hasValue($('#LoginMethod'));
            const formGroupWebPermission = $('.form-group-web-permission');
            formGroupWebPermission.closest('.card').hideElement();

            // ensure that when Web Access is set for the first time or changed that we default both options - Manage Users & Can Switch Context to false
            const level = $('#UserDetail_Level').val() as string ?? '';

            $('.permission-ManageUsers input').prop('checked',
                !['ReadOnly', 'User'].includes(level));

            if (_initArgs.isEnterpriseToolkit) {
                $('.permission-CanSwitchContext input').prop('checked',
                    !['ReadOnly', 'User', 'Admin'].includes(level));
            }

            if (hasAuthMethods || $(this).prop('checked'))
                formGroupWebPermission.closest('.card').showElement();

            if ($(this).prop('checked')) {
                formGroupWebPermission.showElement();
                formGroupWebPermission.closest('.collapsed-card.card-btn-expand-or-collapse').click();
            } else
                formGroupWebPermission.hideElement();
        });

        $('#UserDetail_Level').change(function() {
            togglePerms();
        });

        $('#LoginMethod').change(function() {
            const loginMethod = $('#LoginMethod').val();
            if (loginMethod === 'None')
                $('#verifyCodeFormGroup').removeClass('d-none');
            else
                $('#verifyCodeFormGroup').addClass('d-none');
        });

        $(document).on('click', '.addMetaItem', function(e): void {
            e.preventDefault();

            if ($('#metaData tbody').children().length === 0) {
                $('#metaData').show();
                $('.addMetaItem').css('top', '0px');
            }

            const idx = $('#metaData tbody').children().length;

            const newRow = `<tr>` +
                `<td class="dataCol name"><input class="form-control form-control-sm metaDataKey" type="text" name="UserDetail.MetaData[${idx}].Key" class="valid"></td>` +
                `<td class="dataCol value"><input class="form-control form-control-sm metaDataVal" type="text" name="UserDetail.MetaData[${idx}].Val" class="valid"></td>` +
                `<td class="closeCell">${elementBuilder.buildBtnRemoveRow('delete_button', 'data-tablename="metaData"')}</td></tr>`;

            $('#metaData tbody').append(newRow); 
        });

        $(document).on('click', '.delete_button', function(e) {
            e.preventDefault();
            const tableName = $(this).attr('data-tablename');
            $(this).parents('tr').remove();

            renameRows(tableName);

            if ($('#metaData tbody').children().length === 0) {
                $('#metaData').hide();
                $('.addMetaItem').css('top', '-20px');
            }
        });

        $('#btn-regenIntegrationKey1').on('click', function(e) {
            e.preventDefault();
            regenIntegrationKey($(this), 1);
        });

        $('#btn-regenIntegrationKey2').on('click', function(e) {
            e.preventDefault();
            regenIntegrationKey($(this), 2);
        });

        $('#btn-removeIntegrationKey1').on('click', function(e) {
            e.preventDefault();
            removeIntegrationKey($(this), 1);
        });

        $('#btn-removeIntegrationKey2').on('click', function(e) {
            e.preventDefault();
            removeIntegrationKey($(this), 2);
        });

        addDeleteOrphanedExtraUserInfoEvent();

        if (_initArgs.isEmailessLoginEnabled) {
            $('#UserDetail_LoginId').rules('add', {
                required: true,
                messages: { required: T('The Login ID field is required.') }
            });
        }
        else {
            $('#UserDetail_Email').rules('add', {
                required: true,
                messages: { required: T('The Email address field is required.') }
            });
        }
    }

    function addDeleteOrphanedExtraUserInfoEvent() {
        $('.btn-delete-orphaned-info').off().on('click', function(e) {
            e.preventDefault();
            $(this).closest('.form-group').remove();
            renameOrphanedExtraUserInfo();
        });
    }

    function renameRows(tableName?: string): void {
        if (tableName === 'metaData')
            renameMetaData();
    }

    function togglePerms(firstLoad?: boolean): void {
        const level = $('#UserDetail_Level').val();
        $('.accessperm').not('.lvl-' + level).hide();
        $('.accessperm.lvl-' + level).show();

        // make implicit permissions read-only but still post back
        $('.accessperm').not('.imp-' + level).find('.appn-checkbox').off().css('opacity', '1');
        const checkBox = $('.accessperm.imp-' + level + ' .appn-checkbox');
        checkBox.find('input[id]').prop('checked', 'checked');
        checkBox.on('click', function(event) {
            event.preventDefault();
        }).css('opacity', '0.5');

        if (firstLoad)
            return;

        if ($.inArray(level, ['ReadOnly', 'User']) >= 0)
            $('.permission-ManageUsers input').prop('checked', false);
        else
            $('.permission-ManageUsers input').prop('checked', true);

        if (_initArgs.isEnterpriseToolkit)
            if ($.inArray(level, ['ReadOnly', 'User', 'Admin']) >= 0)
                $('.permission-CanSwitchContext input').prop('checked', false);
            else
                $('.permission-CanSwitchContext input').prop('checked', true);
    }

    function renameMetaData() {
        // rename all remaining rows to keep continuous index
        let idx = 0;
        $('#metaData tbody tr').each(function(index: number, row: HTMLElement): any {
            $(this).find('.metaDataKey').attr('name', `UserDetail.MetaData[${idx}].Key`);
            $(this).find('.metaDataVal').attr('name', `UserDetail.MetaData[${idx}].Val`);
            idx++;
        });
    }

    function renameOrphanedExtraUserInfo() {
        // rename all remaining rows to keep continuous index
        let idx = 0;
        $('.form-control-extraUserInfo.fromUserConfig').each(function(index: number, row: HTMLElement): any {
            $(row).find('.valueFromDsRowSelectList')
                .attr('name', `UserDetail.Config.ExtraUserInfo[${idx}].DefaultValueFromDsRow`)
                .attr('id', `UserDetail_Config_ExtraUserInfo_${idx}__DefaultValueFromDsRow`);

            $(row).find('.extraUserInfoDefaultValue')
                .attr('name', `UserDetail.Config.ExtraUserInfo[${idx}].DefaultValue`)
                .attr('id', `UserDetail_Config_ExtraUserInfo_${idx}__DefaultValue`);

            $(row).find('.extraUserInfoDataSourceColRowIdentifier')
                .attr('name', `UserDetail.Config.ExtraUserInfo[${idx}].DataSourceColRowIdentifier`)
                .attr('id', `UserDetail_Config_ExtraUserInfo_${idx}__DataSourceColRowIdentifier`);

            $(row).find('.extraUserInfoDataSource')
                .attr('name', `UserDetail.Config.ExtraUserInfo[${idx}].DataSourceId`)
                .attr('id', `UserDetail_Config_ExtraUserInfo_${idx}__DataSourceId`);

            $(row).find('.extraUserInfoFieldName')
                .attr('name', `UserDetail.Config.ExtraUserInfo[${idx}].FieldName`)
                .attr('id', `UserDetail_Config_ExtraUserInfo_${idx}__FieldName`);

            $(row).find('.extraUserInfoRequired')
                .attr('name', `UserDetail.Config.ExtraUserInfo[${idx}].Required`)
                .attr('id', `UserDetail_Config_ExtraUserInfo_${idx}__Required`);

            $(row).find('.extraUserInfoFieldId')
                .attr('name', `UserDetail.Config.ExtraUserInfo[${idx}].Id`)
                .attr('id', `UserDetail_Config_ExtraUserInfo_${idx}__Id`);
            
            idx++;
        });
    }

    function regenIntegrationKey(regenButton: JQuery<HTMLElement>, userApiNumber: number): void {
        const closestInputGroup = regenButton.closest('.input-group').find('input');
        const thisKey = (closestInputGroup.val() as string);

        appn.dialog.confirm({
            modalColor: 'modal-warning',
            title: T('Regenerate Access Key'),
            message: T('This action will reset Key <b>{0}</b> to a new value.<br><br>Any API requests using the above Key value will fail after regeneration, which may cause issues for API integrations with our platform.<br><br><b>Ensure that your API integrations are using the other available Key before proceeding.</b>', thisKey),
            buttons: {
                confirm: {
                    label: '<span>' + T('OK') + '</span>',
                    className: 'btn-success'
                }
            },
            callback: function(result: any) {
                if (result) {
                    appn.dialog.showLoading();
                    closestInputGroup.val(appn.emptyString);

                    const $form = $('form#appnForm');
                    $form.append('<input type="hidden" name="RegenAPIKey' + userApiNumber + '" value="true" />');
                    $form.append('<input type="hidden" name="submitType" value="Save" />');
                    $form.submit();
                }
            }
        });
    }

    function removeIntegrationKey(removeButton: JQuery<HTMLElement>, userApiNumber: number) {
        const closestInputGroup = removeButton.closest('.input-group').find('input');
        const thisKey = (closestInputGroup.val() as string);

        appn.dialog.confirm({
            modalColor: 'modal-danger',
            title: T('Remove Access Key'),
            message: T('This action will remove Key <b>{0}</b> completely.<br><br>Any API requests using the above Key value will fail after removal, which may cause issues for API integrations with our platform.<br><br><b>Ensure that your API integrations are not using this Key before proceeding.</b>', thisKey),
            buttons: {
                confirm: {
                    label: '<span>' + T('OK') + '</span>',
                    className: 'btn-success'
                }
            },
            callback: function(result: any) {
                if (result) {
                    appn.dialog.showLoading();
                    closestInputGroup.val(appn.emptyString);

                    const $form = $('form#appnForm');
                    $form.append('<input type="hidden" name="RemoveAPIKey' + userApiNumber + '" value="true" />');
                    $form.append('<input type="hidden" name="submitType" value="Save" />');
                    $form.submit();
                }
            }
        });
    }

    function populateDsColumnValuesOnLoad() {
        $.each($('.form-control-extraUserInfo .valueFromDsRowSelectList:not([type="hidden"])'), function(index: number, selList: any) {
            const formGroupExtraUserInfo = $(selList).closest('.form-control-extraUserInfo');
            const dataAsJson = formGroupExtraUserInfo.data('extrauserinfoserialized');

            getDsColumnValues(dataAsJson.DataSourceId as Guid, $(selList), dataAsJson.DataSourceColRowIdentifier);
        });
    }

    function getDsColumnValues(dsId: Guid, defaultValueFromDsRow: JQuery<HTMLElement>, columnName: string) {
        // Spin up
        const closestCol = defaultValueFromDsRow.closest('div');
        appn.ui.spinnerInject(closestCol);
        defaultValueFromDsRow.removeClass('d-none').addClass('d-none');

        defaultValueFromDsRow.html(emptyString);
        appn.ajax.get({
            url: appn.location.buildUrlWithQueryString(_initArgs.dataSourcesAjaxGetDataSourceColumnValues, [{ name: 'dsId', value: dsId }, { name: 'columnName', value: columnName }]),
            done: function(data: any) {

                if (!data) {
                    appn.toast.notify(toast.Type.warning, T('No column data found for {0}', dsId));
                    return;
                }

                // Update the select list with the columns
                defaultValueFromDsRow.html(appn.elementBuilder.buildOptionsListSelectList(data));

                const selectedValueFromServer = defaultValueFromDsRow.attr('selectedValue');
                defaultValueFromDsRow.attr('selectedValue', emptyString); // reset it

                // Set the selected value from the server
                defaultValueFromDsRow.val(selectedValueFromServer as string);
            },
            fail: function() {
                appn.toast.notify(toast.Type.error, T('Error fetching column value data.'));
            },
            always: function() {
                appn.ui.spinnerRemove(closestCol);
                defaultValueFromDsRow.removeClass('d-none');
            }
        });
    }

}

